import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import { MynumberUrls } from '../constants/urls';
import { useSearchParams } from 'react-router-dom';

export const Webview = () => {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const queryString = searchParams.toString();

  function navigateMynumberAuth(): void {
    const authSuccess = MynumberUrls.Success + `?${queryString}`;
    navigate(authSuccess);
  }

  return (
    <Box
      style={{
        width: '100%',
        textAlign: 'center',
        height: '100%',
        marginTop: '60px'
      }}
    >
      <Typography sx={{ fontWeight: 600, fontSize: '18px', lineHeight: 1.5, marginBottom: '24px' }}>
        本人認証を完了する
      </Typography>
      <div className="font-light [font-size: 14px] leading-1.5 my-6">
        <Typography>認証を完了するには</Typography>
        <Typography>次へお進みください</Typography>
      </div>
      <div className="w-[90%] mx-auto mt-4 bg-[#3582BC] text-white" onClick={navigateMynumberAuth}>
        <Button variant="text" className="w-fit cursor-pointer text-white" onClick={navigateMynumberAuth}>
          次へ進む
        </Button>
      </div>
    </Box>
  );
};
